import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    Button, List, ListItem, ListItemText, Typography,
} from '@material-ui/core';
import { AddIcon, CheckOutlinedIcon } from 'components/icons';
import Table from 'components/widgets/Table';
import Header from 'components/widgets/Header';
import InputSearch from 'components/widgets/InputSearch';
import Loading from 'components/widgets/Loading';

const CustomerPanel = ({
    isMobile,
    classes,
    search,
    inHouse,
    showAddNewCustomerButton,
    onClickNewCustomerButton,
    onSearch,
    loadingCustomerInfo,
    records,
    onSelectedRecord,
    getCustomerColumns,
}) => {
    const renderCustomersInCards = () => {
        if (loadingCustomerInfo) return (<Loading className="loading-table" />);

        return (
            <List
                className={classes.list}
            >
                {records.map((record, index) => {
                    const {
                        customerCode,
                        firstName,
                        lastName,
                        cellPhone,
                        email,
                        dln,
                        isTaxable,
                    } = record;

                    const primaryText = (
                        <>
                            <span className={classes.flex}>
                                <Typography component="span" className={classes.textBold} color="textPrimary" align="left" display="inline">
                                    Customer Code: &nbsp;
                                </Typography>
                                <Typography component="span" className={classes.text} color="textSecondary" align="left" display="inline">
                                    {customerCode}
                                </Typography>
                            </span>
                            <span className={classes.flex}>
                                <Typography component="span" className={classes.textBold} color="textPrimary" align="left" display="inline">
                                    First Name: &nbsp;
                                </Typography>
                                <Typography component="span" className={classes.text} color="textSecondary" align="left" display="inline">
                                    {firstName}
                                </Typography>
                            </span>
                            <span className={classes.flex}>
                                <Typography component="span" className={classes.textBold} color="textPrimary" align="left" display="inline">
                                    Last Name: &nbsp;
                                </Typography>
                                <Typography component="span" className={classes.text} color="textSecondary" align="left" display="inline">
                                    {lastName}
                                </Typography>
                            </span>
                            <span className={classes.flex}>
                                <Typography component="span" className={classes.textBold} color="textPrimary" align="left" display="inline">
                                    Cell Phone: &nbsp;
                                </Typography>
                                <Typography component="span" className={classes.text} color="textSecondary" align="left" display="inline">
                                    {cellPhone}
                                </Typography>
                            </span>
                            <span className={classes.flex}>
                                <Typography component="span" className={classes.textBold} color="textPrimary" align="left" display="inline">
                                    Email: &nbsp;
                                </Typography>
                                <Typography component="span" className={classes.text} color="textSecondary" align="left" display="inline">
                                    {email}
                                </Typography>
                            </span>
                            <span className={classes.flex}>
                                <Typography component="span" className={classes.textBold} color="textPrimary" align="left" display="inline">
                                    DLN: &nbsp;
                                </Typography>
                                <Typography component="span" className={classes.text} color="textSecondary" align="left" display="inline">
                                    {dln}
                                </Typography>
                            </span>
                            <span className={classes.flex}>
                                <Typography component="span" className={classes.textBold} color="textPrimary" align="left" display="inline">
                                    Is Taxable: &nbsp;
                                </Typography>
                                {isTaxable && (
                                    <Typography component="span" className={classes.text} color="textSecondary" align="left" display="inline">
                                        <span><CheckOutlinedIcon fontSize="small" /></span>
                                    </Typography>
                                )}
                            </span>
                        </>
                    );

                    return (
                        <React.Fragment key={index}>
                            <ListItem
                                className={classes.listItem}
                                button
                                onClick={() => {
                                    onSelectedRecord(record);
                                }}
                            >
                                <ListItemText primary={primaryText} />
                            </ListItem>
                        </React.Fragment>
                    );
                })}
            </List>
        );
    };

    return (
        <div className={classes.main}>
            <Header className={classes.customerSection}>
                <InputSearch
                    autoFocus
                    customClasses={clsx(search)}
                    onSearch={onSearch}
                />
                {!inHouse && showAddNewCustomerButton && (
                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<AddIcon />}
                        size="small"
                        onClick={onClickNewCustomerButton}
                    >
                        Add new customer
                    </Button>
                )}
            </Header>
            {isMobile && renderCustomersInCards()}
            {!isMobile && (
                <div className={classes.mainTable}>
                    <Table
                        rowSelected
                        cursor="default"
                        load={loadingCustomerInfo}
                        totalRecords={records.length || 0}
                        data={loadingCustomerInfo ? [] : records}
                        columns={getCustomerColumns()}
                        enableRowHover
                        getTrProps={(_, rowInfo) => ({
                            onDoubleClick: () => {
                                onSelectedRecord(rowInfo.original);
                            },
                            onClick: () => {
                                onSelectedRecord(rowInfo.original);
                            },
                        })}
                    />
                </div>
            )}
        </div>
    );
};

CustomerPanel.propTypes = {
    classes: PropTypes.object.isRequired,
    search: PropTypes.string,
    inHouse: PropTypes.bool.isRequired,
    showAddNewCustomerButton: PropTypes.bool,
    onClickNewCustomerButton: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    loadingCustomerInfo: PropTypes.bool,
    records: PropTypes.array.isRequired,
    onSelectedRecord: PropTypes.func.isRequired,
    getCustomerColumns: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
};

CustomerPanel.defaultProps = {
    search: '',
    showAddNewCustomerButton: false,
    loadingCustomerInfo: false,
};

export default CustomerPanel;
